$('[data-behaviour="toggle-menu"]').on('click', function () {
    $(this).toggleClass('active');
});